import { Modal } from "antd";
import { Alert } from "components/elements";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { THEME_COLOR } from "../schemas/companyAppearanceSchema";
import { changeCompanyTheme } from "../services/companyApi";
import { setIsLoading } from "../slices/companySlice";

function useCompanyAppearance(props = {}) {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch()
    const { currentCompany, companyList } = useSelector((state) => state.company)
    const initialThemeCode = companyList?.find?.(o => o?.companyId == currentCompany)?.themeConfig?.code;
    const [currentTheme, setCurrentTheme] = useState(initialThemeCode);
    const [initialTheme, setInitialTheme] = useState(initialThemeCode);

    // console.log("currentCompany?.themeConfig?.code", currentCompany, companyList?.find?.(o => o?.companyId == currentCompany));

    const [isDisabled, setIsDisabled] = useState(true);

    useEffect(() => {
        setInitialTheme(initialThemeCode);
    }, [initialThemeCode]);

    const changeTheme = (theme) => {
        setCurrentTheme(theme.code);
        setIsDisabled(theme.code === initialTheme);
    };

    const onCancel = () => {
        setCurrentTheme(initialTheme);
        setIsDisabled(true);
    };

    const resetTheme = useCallback(
        () => {
            Modal.confirm({
                title: t("dialog.confirmation.header"),
                content: (i18n.language === "en"
                    ? <span>Are you sure confirm to reset theme to deafault ?</span>
                    : <span>คุณแน่ใจที่จะคืนค่าธีมเป็นค่าเริ่มต้นใช่หรือไม่ ?</span>
                ),
                onOk: async () => {
                    const defaultTheme = THEME_COLOR.find((theme) => theme.code === "DEFAULT");
                    if (defaultTheme) {
                        setCurrentTheme(defaultTheme.code);
                        setIsDisabled(true);

                        const theme = defaultTheme;
                        const root = document.documentElement;
                        root.style.setProperty("--sidebar-menu-color", theme.color.sidebarMenu);
                        root.style.setProperty("--sidebar-sub-menu-color", theme.color.subSidebarMenu);
                        root.style.setProperty("--table-paginate-color", theme.color.paginateBg);
                        root.style.setProperty("--tab-color", theme.color.tabHighlight);
                        root.style.setProperty("--button-color", theme.color.buttonBG);

                        try {
                            dispatch(setIsLoading(true))
                            const response = await changeCompanyTheme({
                                companyId: currentCompany,
                                code: defaultTheme?.code
                            })
                            if (response?.data?.status?.code != 200) {
                                Alert({ type: "error", message: response?.data?.status?.description });
                            } else {
                                Alert({ type: "success" });
                                setInitialTheme(defaultTheme.code);
                            }
                        } catch (error) {
                            Alert({ type: 'error', resultObject: error })
                        } finally {
                            dispatch(setIsLoading(false))
                        }
                    }
                },
                okText: t("common.confirm").toUpperCase(),
                cancelText: t("common.cancel").toUpperCase()
            })
        }, [currentCompany, currentTheme]
    )

    const onSubmit = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))
            const response = await changeCompanyTheme({
                companyId: currentCompany,
                code: currentTheme
            })
            if (response?.data?.status?.code != 200) {
                Alert({ type: "error", message: response?.data?.status?.description });
            } else {
                Alert({ type: "success" });
                setInitialTheme(currentTheme);

                let theme = THEME_COLOR?.find?.(o => o.code == currentTheme)
                const root = document.documentElement;
                root.style.setProperty("--sidebar-menu-color", theme.color.sidebarMenu);
                root.style.setProperty("--sidebar-sub-menu-color", theme.color.subSidebarMenu);
                root.style.setProperty("--table-paginate-color", theme.color.paginateBg);
                root.style.setProperty("--tab-color", theme.color.tabHighlight);
                root.style.setProperty("--button-color", theme.color.buttonBG);

                setIsDisabled(true);
            }
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentTheme, currentCompany])


    return {
        themeColor: THEME_COLOR,
        changeTheme,
        onCancel,
        onSubmit,
        currentTheme,
        isDisabled,
        resetTheme,
        permissions: props?.permissions
    };
}

export default useCompanyAppearance;